<template>
  <div :id="id" :year="year"></div>
</template>

<script>
import EmCommonApi from "@/mixin/em/common/api";
import * as echarts from 'echarts';

export default {
  name: "chartType",
  mixins: [EmCommonApi],
  props: {
    id: String,
    year: String,
  },
  data() {
    return {
      chart: {},
      //dataName :[],
      dataValue :[],
      option: {},
      fresh: {},
    }
  },
  created() {
    //子组件自己初始化年份
    if(this.year === ""){
      this.year = new Date().getFullYear();
    }
  },
  mounted() {
    window.addEventListener('resize', this.chart.resize, false)

    //这里可以屏蔽了，用watch生命周期监控year就可以触发了
    //this.getRemoteData();


    //这种子组件的方式传递props给data，定时器刷新没有用，想刷新必须load整个
    //  this.fresh = setInterval(() => {
    //    this.getRemoteData();
    //    window.addEventListener('resize', this.chart.resize, false)
    //     },  2000);

  },
  beforeDestroy() {
    //clearInterval(this.fresh);
    window.removeEventListener('resize', this.chart.resize, false)
  },
  watch:{
    year(newValue,oldValue){

        console.log("旧年份：" + oldValue + "传递的新值：" + newValue)
        this.getRemoteData();
    }
  },

  methods: {
    getRemoteData() {
      let _this = this;

      //后端接口调用
      const _api = `${this.$_emApiMixin_moduleBaseApi("emAcctHandleRecordAhr")}/emAcctHandleRecordAhr/echart/chartType`
      console.log("执行后端调用,API：" + _api)
      this.$_emApiMixin_post(_api, {s_year:_this.year},false).then(responseValue => {
        console.log('--------------- 按分类统计 后端返回结果 ----------------')
        console.log(responseValue.data);

        this.dataValue = responseValue.data;

        //【注意】因为是异步调用后端，所以渲染echart也要放在回调函数的then里，否则渲染不出来
        this.loadChart();
      });

    },
    loadChart(){
      //渲染echart
      this.option = {
        title: {
          text: this.year + '年度设备故障分类统计'
        },
        tooltip: {},
        //饼图没有这些属性
        // legend: {
        //   data:['频次']
        // },
        // xAxis: {
        // },
        // yAxis: {},
        series : [
          {
            name: '事故分类',
            type: 'pie',
            radius: '55%',
            data: this.dataValue,
            //roseType: 'angle',
            // itemStyle: {
            //   normal: {
            //     shadowBlur: 200,
            //     shadowColor: 'rgba(0, 0, 0, 0.5)'
            //   }
            // }
          }
        ]
      };


      //load chart
      this.chart = echarts.init(document.getElementById(this.id));
      this.chart.setOption(this.option)

      //echart浏览器自动缩放
      let myChart = this.chart;
      window.addEventListener('resize',()=>{
        myChart.resize();
      })
    }
  }
}
</script>

<style scoped>

</style>
